export default ({ route, app: { $config } }) => {
  if (
    // This should only happen in the browser.
    !process.client ||
    // This value is set by `modules/builder/plugins/router.js`, and will be true
    // if the routes are related to the tool and not the publisher website. We don't
    // want to load the script for published websites.
    (process.client && !window.__NUXT__.isWebFrontendHostname)
  ) {
    return
  }

  // Keep in sync with
  // `plugins/saas/backend/src/saas/pipedrive/api.py::get_track_custom_fields_data::param_to_field_id`
  const allowedParams = [
    'gclid',
    'utm_medium',
    'utm_source',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ]

  const captured = {}
  Object.keys(route.query).forEach((key) => {
    const lowerCaseKey = key.toLowerCase()
    if (allowedParams.includes(lowerCaseKey)) {
      captured[lowerCaseKey] = route.query[key]
    }
  })

  try {
    const stored = JSON.parse(localStorage.getItem('trackedParams') || '{}')
    const updated = { ...stored, ...captured }
    localStorage.setItem('trackedParams', JSON.stringify(updated))
  } catch (e) {
    console.error('Failed to update localStorage:', e)
  }
}
